import useHallFilterHook from "./use-hall-filter-hook";


const HallHooks = {
    useFilter : useHallFilterHook
};

export default HallHooks;